import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'any' })
export class ProtectLunStrService {
    constructor(
        private i18nService: I18nService,
    ) { }

    lun = {
        cdpToolTip: this.get('protection.protection_simplifiedMode_scheduledSnap_tip'),
        creatSingleSnap: this.get('protection.protection_simplifiedMode_createOneOffSnap_btn'),
        addToCdpSchedule: this.get('protection.protection_simplifiedMode_createPolicyProtection_btn'),
        addToCdpScheduleBtnTip: this.get('protection.protection_simplifiedMode_createPolicyProtection_err_info'),

        modifyCdpSchedule: this.get('protection.protection_simplifiedMode_modifySnapPolicy_btn'),
        removeFromCdpSchedule: this.get('protection.protection_simplifiedMode_disablePolicyProtection_btn'),
        modifyCdpScheduleBtnTip: this.get('protection.protection_simplifiedMode_disablePolicyProtection_err_info'),

        openCdpEnableSwitch: this.get('protection.protection_simplifiedMode_enableScheduledSnap_btn'),
        closeCdpEnableSwitch: this.get('protection.protection_simplifiedMode_disableScheduledSnap_btn'),
        openCdpEnableSwitchDisabledTip: this.get('protection.protection_simplifiedMode_enableScheduledSnap_err_tip'),
        closeCdpEnableSwitchDisabledTip: this.get('protection.protection_simplifiedMode_disableScheduledSnap_err_tip'),
        cdpEnableSwitchLabel: this.get('protection.protection_simplifiedMode_ScheduledSnapSwitch_col'),
        openCdpEnableSwitchMsg: (name: string): string => this.get('rest.enableScheduledSnap_msg', [name]),
        closeCdpEnableSwitchMsg: (name: string): string => this.get('rest.disableScheduledSnap_msg', [name]),

        createProtect: this.get('protection.protect_simplifiedMode_configProtection_btn'),
        addToCdpPlan: this.get('storage.lun_task_addtoHyperCDPSchedule_button'),
        singleSnap: this.get('storage.lun_simplifiedMode_Snap_tab'),
        cdpScheduleLab: this.get('storage.lun_task_addToHyperCDPScheduley_HyperCDPSchedule_label'),

        // 删除LUN
        deleteLun: this.get('storage.lun_task_delete_title'),
        restore: this.get('common.startRollback_button'),
        stopRestore: this.get('common.stopRollback_button'),
        snapshot: this.get('common.snapshot_title'),
        clone: this.get('common.clone_button'),
        cdp: this.get('protection.HyperCDP_title'),
        protect: this.get('common.protection_title'),
        createSnapshot: this.get('protection.protectionGroup_createSnapshot_button'),
        createClone: this.get('protection.clone_task_createClone_button'),
        delete: this.get('common.delete_button'),
        name: this.get('common.name_column'),
        healthStatus: this.get('common.healthStatus_column'),
        modify: this.get('common.modify_button'),
        cancelBtnLabel: this.get('common.cancel_button'),
        closeBtnLabel: this.get('common.close_button'),
        createMetroPairBtn: this.get('protection.protectionGroup_task_createHyperMetro_button'),
        hyperMetro: this.get('common.HyperMetro_title'),
        repPairBtnLabel: this.get('protection.replicationCG_task_create_remoteRepliPair_lab'),
        cerateDrStarBtn: this.get('protection.dataProtection_term_drStar_create_button'),
        createRepPair: this.get('protection.protectionGroup_createReplication_button'),
        hyperMetroLab: this.get('common.HyperMetro_title'),
        replication: this.i18nService.get('common.replication_title'),
        snapshots: this.get('common.snapshots'),
        clonePairs: this.get('common.clonePairs'),
        cdpObjects: this.get('protection.HyperCDP_Objects_column'),
        replicationPairs: this.i18nService.get('common.RemoteReplicationPairs'),
        hyperMetroPairs: this.get('common.HyperMetroPairs'),
        drStar: this.i18nService.get('protection.dataProtection_term_drStar_featureName'),
        drStarLabel: this.i18nService.get('protection.dataProtection_term_drStarTrios'),
        createRepBtnTips: this.get('protection.dataProtection_term_createdrStar_repRemotePair_buttonTips'),
        createHyperMetroBtnTips: this.get('protection.dataProtection_term_createdrStar_hyperMetroPair_buttonTips'),
        createDrStarBtnTips: this.get('protection.dataProtection_term_createdrStar_LUN_buttonTips'),

        filterLunMsg: this.get('storage.lun_task_createProtection_info_msg'),
    };

    detail = {
        cdpToolTip: this.get('protection.protection_simplifiedMode_scheduledSnap_tip'),
        tabRadioSnap: this.get('protection.protection_simplifiedMode_OneOffSnap_tab'),
        tabRadioCdp: this.get('protection.protection_simplifiedMode_hyperCDP_tab'),
        createSnapshot: this.get('protection.protectionGroup_createSnapshot_button'),
        createClone: this.lun.createClone,
        snapshot: this.lun.snapshot,
        clone: this.lun.clone,
        cdp: this.lun.cdp,
        modify: this.get('common.modify_button'),
        delete: this.get('common.delete_button'),
        operationBtn: this.get('common.operation_button'),
        createDrStarBtnTips: this.get('protection.dataProtection_term_createdrStar_LUN_buttonTips'),
    };

    // 健康状态
    HEALTHSTATUS = {
        1: this.get('common.EnumDefine_STATUS_E_NORMAL'),
        2: this.get('common.EnumDefine_HEALTH_STATUS_fault'),
        15: this.get('common.EnumDefine_HEALTH_STATUS_E_WRITE_PROTECT'),
    };

    getUnavailableMsg(name: string): string {
        return this.get('storage.lun_task_createProtection_oneMember_info_msg', [name]);
    }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

    /**
     * lun CDP计划创建快照开关label
     */
    lunCdpEnableSwitchLabel = {
        true: this.get('common.enabled_switch_column'),
        false: this.get('common.service_disable_value'),
    };
}

